import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1rem;
`;

export const noData = styled.div`
	width: 100%;
	height: 100%;
	padding: 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	background-color: ${color.interface.white};
	border-radius: 5px;

	> p {
		font-size: 1.5rem;
		color: ${color.interface.darkgray3};
	}
`;

export const listPage = styled.div`
	width: 99%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;

	@media (max-width: 650px) {
		grid-template-columns: 1fr;
	}
`;

export const page = styled.div`
	width: 100%;
	height: 5rem;
	background-color: ${color.interface.white};
	padding: 1rem;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	> p {
		font-size: 1.5rem;
		color: ${color.interface.darkgray};
	}
`;

export const btns = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> a {
		all: unset;
		display: flex;
		align-items: center;
		justify-content: center;
		> svg {
			font-size: 2rem;
			color: ${color.interface.darkgray3};
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				color: ${color.system.info};
			}
		}
	}

	> svg {
		font-size: 2rem;
		color: ${color.interface.darkgray3};
		cursor: pointer;
		transition: all 0.3s;
		&:hover {
			color: ${color.system.info};
		}
	}
`;
